export default "__VITE_ASSET__IsJMlhnw__"